var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: {
            "tab-click": function ($event) {
              _vm.tableData = []
              _vm.searchAct()
            },
          },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "线上数据", name: "1" } }),
          _c("el-tab-pane", { attrs: { label: "本地数据", name: "0" } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "search_group" },
        [
          _c("el-input", {
            attrs: {
              maxlength: 30,
              size: "small",
              placeholder: "输入商品编号",
            },
            model: {
              value: _vm.productCode,
              callback: function ($$v) {
                _vm.productCode = $$v
              },
              expression: "productCode",
            },
          }),
          _c("el-input", {
            attrs: {
              maxlength: 30,
              size: "small",
              placeholder: "输入商品名称",
            },
            model: {
              value: _vm.searchName,
              callback: function ($$v) {
                _vm.searchName = $$v
              },
              expression: "searchName",
            },
          }),
          _c(
            "el-select",
            {
              attrs: {
                filterable: "",
                clearable: "",
                size: "small",
                placeholder: "会员类型名称",
              },
              on: { change: _vm.searchAct },
              model: {
                value: _vm.productType,
                callback: function ($$v) {
                  _vm.productType = $$v
                },
                expression: "productType",
              },
            },
            _vm._l(_vm.productTypeList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.typeName, value: item.id },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              attrs: {
                clearable: "",
                size: "small",
                placeholder: "会员售价状态",
              },
              on: { change: _vm.searchAct },
              model: {
                value: _vm.priceStatus,
                callback: function ($$v) {
                  _vm.priceStatus = $$v
                },
                expression: "priceStatus",
              },
            },
            [
              _c("el-option", { attrs: { label: "生效", value: 1 } }),
              _c("el-option", { attrs: { label: "失效", value: 2 } }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              attrs: { clearable: "", size: "small", placeholder: "销售渠道" },
              on: { change: _vm.searchAct },
              model: {
                value: _vm.isIos,
                callback: function ($$v) {
                  _vm.isIos = $$v
                },
                expression: "isIos",
              },
            },
            [
              _c("el-option", { attrs: { label: "非IOS内购", value: 0 } }),
              _c("el-option", { attrs: { label: "IOS内购", value: 1 } }),
            ],
            1
          ),
          _vm.activeName == "0"
            ? _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    size: "small",
                    placeholder: "审核状态",
                  },
                  on: { change: _vm.searchAct },
                  model: {
                    value: _vm.checkStatus,
                    callback: function ($$v) {
                      _vm.checkStatus = $$v
                    },
                    expression: "checkStatus",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "草稿", value: 0 } }),
                  _c("el-option", { attrs: { label: "待审核", value: 1 } }),
                  _c("el-option", { attrs: { label: "通过", value: 2 } }),
                  _c("el-option", { attrs: { label: "不通过", value: 3 } }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-search", size: "small", type: "primary" },
              on: { click: _vm.searchAct },
            },
            [_vm._v("搜索")]
          ),
          _vm.activeName == "0"
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "memberAuth_add",
                      expression: "'memberAuth_add'",
                    },
                  ],
                  attrs: {
                    icon: "el-icon-plus",
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.openEdit },
                },
                [_vm._v("新增")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          key: _vm.activeName,
          attrs: {
            "cell-style": { "text-align": "center" },
            "header-cell-style": { "text-align": "center" },
            "max-height": _vm.tableHeight,
            "element-loading-text": "加载中",
            border: "",
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: { fixed: "", label: "ID", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm.activeName == "0"
                          ? scope.row.originalId
                          : scope.row.id
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "productCode", label: "商品编号", width: "200" },
          }),
          _c("el-table-column", {
            attrs: { prop: "name", label: "商品名称", width: "200" },
          }),
          _c("el-table-column", { attrs: { prop: "sort", label: "显示顺序" } }),
          _c("el-table-column", {
            attrs: { prop: "orderPlacerName", label: "前端可见" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        scope.row.isShow == 1
                          ? "可见"
                          : scope.row.isShow == 0
                          ? "不可见"
                          : ""
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "productTypeName",
              label: "会员类型名称",
              width: "150",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "shortDesc", label: "短描述" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "mediumDesc",
              "show-overflow-tooltip": "",
              label: "中描述",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "longDesc",
              "show-overflow-tooltip": "",
              label: "长描述",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "periodValue", label: "定价周期" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(scope.row.periodValue) +
                        _vm._s(scope.row.periodTypeName)
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "originalPrice", label: "售价（元）", width: "100" },
          }),
          _c("el-table-column", {
            attrs: { label: "可购买次数", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        scope.row.isOnlyOnce == 1
                          ? "一次"
                          : scope.row.isOnlyOnce == 0
                          ? "无限次"
                          : ""
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "销售渠道", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        scope.row.isIos == 1
                          ? "IOS内购"
                          : scope.row.isIos == 0
                          ? "非IOS内购"
                          : ""
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "会员售价状态", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        scope.row.status == 1
                          ? "生效"
                          : scope.row.status == 2
                          ? "失效"
                          : ""
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.activeName == "0"
            ? _c("el-table-column", {
                attrs: { label: "审核状态" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm._f("reviewStatus")(scope.row.reviewStatus)
                            )
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  811752964
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              prop: "remark",
              "show-overflow-tooltip": "",
              label: "备注",
            },
          }),
          _vm.activeName == "0"
            ? _c("el-table-column", {
                attrs: { fixed: "right", width: "250", label: "操作" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.reviewStatus == 0 ||
                          scope.row.reviewStatus == 4
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "memberAuth_submitCheck",
                                      expression: "'memberAuth_submitCheck'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-info",
                                    size: "mini",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitCheck(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("提交审核")]
                              )
                            : _vm._e(),
                          scope.row.reviewStatus == 1
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "memberAuth_check",
                                      expression: "'memberAuth_check'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-info",
                                    size: "mini",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openCheck(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("审核")]
                              )
                            : _vm._e(),
                          scope.row.reviewStatus == 1
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "memberAuth_cancelCheck",
                                      expression: "'memberAuth_cancelCheck'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-info",
                                    size: "mini",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeCheck(scope.row, 4)
                                    },
                                  },
                                },
                                [_vm._v("撤销审核")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "memberAuth_viewLog",
                                  expression: "'memberAuth_viewLog'",
                                },
                              ],
                              attrs: {
                                icon: "el-icon-view",
                                size: "mini",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openLog(scope.row)
                                },
                              },
                            },
                            [_vm._v("查看日志")]
                          ),
                          _vm.activeName == "0" && scope.row.reviewStatus !== 1
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "memberAuth_change",
                                      expression: "'memberAuth_change'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-edit",
                                    size: "small",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openEdit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("修改")]
                              )
                            : _vm._e(),
                          _vm.activeName == "0"
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "memberAuth_delete",
                                      expression: "'memberAuth_delete'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-delete",
                                    size: "small",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delProduct(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1673831799
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table_pagination" },
        [
          _c("el-pagination", {
            staticClass: "app-pagination",
            attrs: {
              background: "",
              "current-page": _vm.pageNo,
              "page-sizes": _vm.pageSizeArr,
              "page-size": _vm.pageSize,
              layout: _vm.paginationLayout,
              total: _vm.totalEl,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审核会员售价",
            top: "10%",
            "custom-class": "member-approve-popups",
            visible: _vm.showCheck,
            "append-to-body": "",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCheck = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.checkItem,
                size: "mini",
                "label-width": "110px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "商品编号" } }, [
                _vm._v(_vm._s(_vm.checkItem.productCode)),
              ]),
              _c("el-form-item", { attrs: { label: "商品名称" } }, [
                _vm._v(_vm._s(_vm.checkItem.name)),
              ]),
              _c("el-form-item", { attrs: { label: "会员类型名称" } }, [
                _vm._v(_vm._s(_vm.checkItem.productTypeName)),
              ]),
              _c("el-form-item", { attrs: { label: "短描述" } }, [
                _vm._v(_vm._s(_vm.checkItem.shortDesc)),
              ]),
              _c("el-form-item", { attrs: { label: "中描述" } }, [
                _vm._v(_vm._s(_vm.checkItem.mediumDesc)),
              ]),
              _c("el-form-item", { attrs: { label: "长描述" } }, [
                _vm._v(_vm._s(_vm.checkItem.longDesc)),
              ]),
              _c("el-form-item", { attrs: { label: "定价周期" } }, [
                _vm._v(
                  _vm._s(_vm.checkItem.periodValue) +
                    _vm._s(_vm.checkItem.periodTypeName)
                ),
              ]),
              _c("el-form-item", { attrs: { label: "售价" } }, [
                _vm._v(_vm._s(_vm.checkItem.originalPrice) + "元"),
              ]),
              _c("el-form-item", { attrs: { label: "可购买次数" } }, [
                _vm._v(
                  _vm._s(
                    _vm.checkItem.isOnlyOnce == 1
                      ? "一次"
                      : _vm.checkItem.isOnlyOnce == 0
                      ? "无限次"
                      : ""
                  )
                ),
              ]),
              _c("el-form-item", { attrs: { label: "终端可见" } }, [
                _vm._v(
                  _vm._s(
                    _vm.checkItem.isShow == 1
                      ? "是"
                      : _vm.checkItem.isShow == 0
                      ? "否"
                      : ""
                  )
                ),
              ]),
              _c("el-form-item", { attrs: { label: "会员售价状态" } }, [
                _vm._v(
                  _vm._s(
                    _vm.checkItem.status == 1
                      ? "生效"
                      : _vm.checkItem.status == 2
                      ? "失效"
                      : ""
                  )
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "审核意见" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: 150,
                      resize: "none",
                      placeholder: "请输入审核意见",
                    },
                    model: {
                      value: _vm.checkMark,
                      callback: function ($$v) {
                        _vm.checkMark = $$v
                      },
                      expression: "checkMark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "memberAuth_check",
                      expression: "'memberAuth_check'",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeCheck(_vm.checkItem, 2)
                    },
                  },
                },
                [_vm._v("同意审核")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "memberAuth_check",
                      expression: "'memberAuth_check'",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "danger",
                    icon: "el-icon-circle-close",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeCheck(_vm.checkItem, 3)
                    },
                  },
                },
                [_vm._v("拒绝审核")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.showCheck = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "操作日志",
            visible: _vm.showLog,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showLog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { height: 400, border: "", data: _vm.logData } },
            [
              _c("el-table-column", {
                attrs: { prop: "applyUserName", label: "申请人" },
              }),
              _c("el-table-column", {
                attrs: { prop: "applyTime", label: "申请时间", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "operationType", label: "操作类型" },
              }),
              _c("el-table-column", {
                attrs: { prop: "reviewUserName", label: "审核人" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "reviewContent",
                  "show-overflow-tooltip": "",
                  label: "审核内容",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "reviewTime", label: "审核时间", width: "180" },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      _vm.showLog = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.checkItem.id ? "修改会员售价" : "新增会员售价",
            "custom-class": "member-form-popups",
            visible: _vm.showEdit,
            "append-to-body": "",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showEdit = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "member-form__wrap" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.checkItem,
                    "label-width": "110px",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品编号", prop: "productCode" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: 30,
                          size: "small",
                          placeholder: "请输入商品编号",
                        },
                        model: {
                          value: _vm.checkItem.productCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "productCode", $$v)
                          },
                          expression: "checkItem.productCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: 30,
                          size: "small",
                          placeholder: "请输入商品名称",
                        },
                        model: {
                          value: _vm.checkItem.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "name", $$v)
                          },
                          expression: "checkItem.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "显示顺序", prop: "sort" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          size: "small",
                          step: 1,
                          min: 1,
                          max: 9999999999,
                        },
                        model: {
                          value: _vm.checkItem.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "sort", $$v)
                          },
                          expression: "checkItem.sort",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "会员类型", prop: "productType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "small",
                            placeholder: "选择会员类型名称",
                          },
                          model: {
                            value: _vm.checkItem.productType,
                            callback: function ($$v) {
                              _vm.$set(_vm.checkItem, "productType", $$v)
                            },
                            expression: "checkItem.productType",
                          },
                        },
                        _vm._l(_vm.inUseProdType, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.typeName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "短描述" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: 30,
                          size: "small",
                          placeholder: "请输入短描述",
                        },
                        model: {
                          value: _vm.checkItem.shortDesc,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "shortDesc", $$v)
                          },
                          expression: "checkItem.shortDesc",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "中描述" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: 50,
                          size: "small",
                          placeholder: "请输入中描述",
                        },
                        model: {
                          value: _vm.checkItem.mediumDesc,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "mediumDesc", $$v)
                          },
                          expression: "checkItem.mediumDesc",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "长描述" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          maxlength: 100,
                          resize: "none",
                          placeholder: "请输入长描述",
                        },
                        model: {
                          value: _vm.checkItem.longDesc,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "longDesc", $$v)
                          },
                          expression: "checkItem.longDesc",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "定价周期", prop: "periodValue" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "input-with-select",
                          attrs: { placeholder: "请输入定价周期" },
                          model: {
                            value: _vm.checkItem.periodValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.checkItem, "periodValue", $$v)
                            },
                            expression: "checkItem.periodValue",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { slot: "append" },
                              slot: "append",
                              model: {
                                value: _vm.checkItem.periodType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.checkItem, "periodType", $$v)
                                },
                                expression: "checkItem.periodType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "天", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "月", value: 2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "季", value: 3 },
                              }),
                              _c("el-option", {
                                attrs: { label: "年", value: 4 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "售价", prop: "originalPrice" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          size: "small",
                          precision: 2,
                          step: 0.1,
                          min: 0.01,
                          max: 9999999999,
                        },
                        model: {
                          value: _vm.checkItem.originalPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "originalPrice", $$v)
                          },
                          expression: "checkItem.originalPrice",
                        },
                      }),
                      _vm._v(" 元\n        "),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "销售渠道" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.checkItem.isIos,
                            callback: function ($$v) {
                              _vm.$set(_vm.checkItem, "isIos", $$v)
                            },
                            expression: "checkItem.isIos",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("IOS内购"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("非IOS内购"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "可购买次数" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.checkItem.isOnlyOnce,
                            callback: function ($$v) {
                              _vm.$set(_vm.checkItem, "isOnlyOnce", $$v)
                            },
                            expression: "checkItem.isOnlyOnce",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("无限次"),
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("1次"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "前端可见" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.checkItem.isShow,
                            callback: function ($$v) {
                              _vm.$set(_vm.checkItem, "isShow", $$v)
                            },
                            expression: "checkItem.isShow",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "会员售价状态" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.checkItem.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.checkItem, "status", $$v)
                            },
                            expression: "checkItem.status",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.checkItem.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.checkItem, "status", $$v)
                                },
                                expression: "checkItem.status",
                              },
                            },
                            [_vm._v("生效")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2 },
                              model: {
                                value: _vm.checkItem.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.checkItem, "status", $$v)
                                },
                                expression: "checkItem.status",
                              },
                            },
                            [_vm._v("失效")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          maxlength: 150,
                          resize: "none",
                          placeholder: "请输入备注",
                        },
                        model: {
                          value: _vm.checkItem.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "remark", $$v)
                          },
                          expression: "checkItem.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "memberAuth_change",
                      expression: "'memberAuth_change'",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.saveEdit("ruleForm")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.showEdit = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }